import { useQuery } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { MinutesDetailsApiService } from './services/api';

interface GetCompanyListParams {
	organization_ids: string[];
}

const Service = new MinutesDetailsApiService();

export const useGetCompanyList = (params: GetCompanyListParams) => {
	return useQuery({
		queryKey: ['get-companies-all', params],
		queryFn: async () => Service.getCompanies(params),
		enabled: !!params.organization_ids?.length,
		onError: () => {
			message.error(I18n.get('Ops... something happened!'));
		}
	});
};
